<template>
  <v-container grid-list-md pa-0 fluid>
    <register v-model="userModel" :visibility.sync="dialog" @registered="getUsers()"/>
    <v-layout
      row
      wrap
      align-baseline
      justify-end
      :class="{'rt-5': $vuetify.breakpoint.name !== 'xs'}"
    >
      <v-flex xs12 sm6 md4 mx-2 class="pointer-event-auto">
        <v-text-field
          outline
          single-line
          class="rounded"
          prepend-inner-icon="mdi-magnify"
          label="Search by name"
          v-model="search"
          hide-details
        >
          <v-tooltip top slot="append-outer">
            <v-icon
              medium
              slot="activator"
              @click="dialog = true"
              color="secondary"
              class="px-2"
            >mdi-plus-circle</v-icon>
            <span>New User</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <v-data-table :headers="headers" :items="users" :search="search" disable-initial-sort>
          <template slot="items" slot-scope="props">
            <tr>
              <td>
                {{ props.item.name }}
                <v-chip
                  v-if="props.item.email === user.email"
                  outline
                  single-line
                  color="secondary"
                  small
                >Current User</v-chip>
              </td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.phone }}</td>
              <td>
                <v-chip small v-for="role in props.item.roles" :key="role">{{role}}</v-chip>
              </td>
              <td>{{ props.item.notes }}</td>

              <td>
                <!-- Delete -->
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    :disabled="!isAdmin"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <!-- Edit Roles -->
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    :disabled="!isAdmin"
                    @click="editUser(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Register from "../auth/register.vue";
export default {
  components: {
    Register
  },
  data() {
    return {
      userModel: {},
      dialog: false,
      search: "",
      users: [],
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Phone", value: "phone" },
        { text: "Role", value: "roles" },
        { text: "Notes", value: "notes" },
        { text: "", value: "name", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      isAdmin: "auth/isAdmin"
    })
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    editUser(user) {
      this.userModel = { password: "default", ...user };
      this.dialog = true;
    },
    getUsers() {
      this.axios.get("api/users/").then(resp => {
        this.userModel = {
          email: "",
          phone: "",
          notes: "",
          password: "",
          name: "",
          roles: []
        };
        this.users = resp.data.data;
      });
    },
    confirmDelete(user) {
      const params = {
        mode: "delete",
        message: "Are you sure you want delete this user?",
        title: "Delete user",
        onConfirm: () => this.deleteUser(user)
      };

      this.$modal.show(params);
    },
    async deleteUser(user) {
      await this.axios.delete(`/api/users/${user.id}`);
      this.getUsers();
    }
  }
};
</script>